var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Contatos:" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputMultiTexts", {
            attrs: {
              label: "Email(s)",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              observer: _vm.observer,
              widthColumn: 6,
              maxlengthButtonDisabled: 10
            },
            model: {
              value: _vm.emailsAux,
              callback: function($$v) {
                _vm.emailsAux = $$v
              },
              expression: "emailsAux"
            }
          }),
          _vm._v(" "),
          _c("InputMultiTexts", {
            attrs: {
              label: "Telefone(s)",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              observer: _vm.observer,
              widthColumn: 6,
              maxlengthButtonDisabled: 13,
              marginLeft: true,
              vMask: ["(##) #####-####", "(##) ####-####"]
            },
            model: {
              value: _vm.telefonesAux,
              callback: function($$v) {
                _vm.telefonesAux = $$v
              },
              expression: "telefonesAux"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19344b14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19344b14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/FormulariosProntos/Contatos/Contatos.vue
// module id = null
// module chunks = 